import store from '@/store'
export default [
  {
    path: '/schedules',
    name: 'schedule',
    meta: { requiresAuth: true },
    component: () => import('@/pages/schedule/index.vue'),
    beforeEnter: (to, from, next) => {
      store.dispatch('schedule/dataBeforeCreate')
      next()
    }
  },
  {
    path: '/schedules/create',
    name: 'schedule-create',
    meta: { requiresAuth: true },
    component: () => import('@/pages/schedule/create.vue')
  },
  {
    path: '/schedules/:id',
    name: 'schedule-edit',
    meta: { requiresAuth: true },
    component: () => import('@/pages/schedule/edit.vue'),
    beforeEnter: async (to, from, next) => {
      await store
        .dispatch('schedule/find', to.params.id)
        .then(() => {})
        .catch(error => {
          return Promise.resolve(error)
        })
      next()
    }
  },
  {
    path: '/schedules/:id/show',
    name: 'schedule-show',
    meta: { requiresAuth: true },
    component: () => import('@/pages/schedule/class-schedule.vue'),
    beforeEnter: async (to, from, next) => {
      await store
        .dispatch('schedule/find', to.params.id)
        .then(() => {})
        .catch(error => {
          return Promise.resolve(error)
        })
      next()
    }
  }
]
